import { FC, PropsWithChildren } from "react";
import { Header } from "../Header";
import { Footer } from "../Footer";

type LandingLayoutProps = PropsWithChildren<{}>;
export const LandingLayout: FC<LandingLayoutProps> = ({ children }) => {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
};
